import React from 'react';
import { Skeleton, Card, CardContent, Grid } from '@mui/material';

const ListingsGridLoadingCard = ({ isMapCollapsed }: { isMapCollapsed: boolean }) => {
  const renderSkeletonCard = () => (
    <Card sx={{ borderRadius: 2, width: '100%' }}>
      <CardContent sx={{ padding: 0 }}>
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
        >
          <Skeleton variant="rectangular" width={'100%'} height={'100px'} />

          <Grid container item direction="column" xs={12} sx={{ paddingLeft: 2, paddingRight: 2 }}>
            <Skeleton variant="text" width={'100%'} sx={{ borderRadius: 4 }} />
            <Skeleton variant="text" width={'100%'} sx={{ borderRadius: 4 }} />
          </Grid>

          <Grid
            container
            item
            direction="column"
            gap={1}
            xs={12}
            sx={{ paddingLeft: 2, paddingRight: 2 }}
          >
            <Skeleton variant="rectangular" height={20} width={'100%'} sx={{ borderRadius: 4 }} />
            <Skeleton variant="rectangular" height={20} width={'100%'} sx={{ borderRadius: 4 }} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <Grid container spacing={2}>
      {Array.from(new Array(6)).map((_, index) => (
        <Grid
          item
          md={isMapCollapsed ? 6 : 12}
          lg={isMapCollapsed ? 4 : 12}
          xl={isMapCollapsed ? 4 : 12}
          key={index}
        >
          {renderSkeletonCard()}
        </Grid>
      ))}
    </Grid>
  );
};

export default React.memo(ListingsGridLoadingCard);
